var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g4, _rect, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExecutive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(-803 -967)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 156,
    cy: 156,
    r: 156,
    transform: "translate(803 967)",
    fill: "#caf4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(842.825 663.911)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(108.522 341.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M113.364,356.24c4.166,3.074,2.863,7.434-.422,11.328s-24.209,20.32-25.853,20.283-7.018-5.208-6.288-7.462,16.383-18.924,19.639-21.657S108.486,352.642,113.364,356.24Z",
    transform: "translate(-40.918 -316.872)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M105.888,354.68c-1.969-.094-9.867,2.314-12.277,5.188-3.419,4.071-10.551,11.317-10.551,11.317a18.2,18.2,0,0,0,4.878,6.875,16.691,16.691,0,0,0,7.935,4.08s14.716-15.283,15.836-19.468C112.042,361.424,111.35,354.945,105.888,354.68Z",
    transform: "translate(-36.616 -316.865)",
    fill: "#9a9393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M111.6,348.057s.644,14.912,1.51,15.636c2.7,2.248,12.494,4.148,14.326,8.063,2.22,4.744-9.966,26.039-11.559,33.076s1.7,17.944,2.764,24.851-20.654,15.254-21.451,15.254-7.784-6.536-9.112-8.793-.014-19.956-.014-24.472-1.043-20.337-1.245-21.372a31.282,31.282,0,0,1,.692-13.824c.262-1.459.185-3.9.92-4.835,1.462-1.861,9.582-4.314,9.713-5.243s1.239-13.873,1.239-13.873Z",
    transform: "translate(-30.608 -329.106)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M113.274,353.545l-13.092,7.81-1.875-5.1s-8.6,3.385-9.713,5.243-1.647,5.886-2.014,7.388-.584,8.4,0,14.394c.342,3.51.254,8.143.784,14.115.456,5.111-.108,17.83-.108,17.83s4.878.205,12.442-.162c8.756-.425,17.594-1.764,17.99-2.086,1.687-1.382-.641-14.953-.336-16.448s11.075-27.478,11.249-30.882a6.945,6.945,0,0,0-4.146-6.932C121.875,357.428,113.274,353.545,113.274,353.545Z",
    transform: "translate(-30.776 -318.958)",
    fill: "#b8b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M117.559,355.141s8.528,4.73.06,11.263c-3.653,2.824-21.13,7.194-24.417,8.2-11.759,3.578,6.351,29.646,7.741,31.614a9.008,9.008,0,0,1,1.368,4.656l8.941-.59c3.51.692.539-16.824,1.875-20.457s9.864-24.392,9.864-27.133A7.725,7.725,0,0,0,117.559,355.141Z",
    transform: "translate(-25.166 -316.007)",
    fill: "#a39d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M90.726,354.676l13.243-4.75.316,7.832-4.085,2.476Z",
    transform: "translate(-22.44 -325.649)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M94.049,344.037c3.721-2.553,13.819-3.949,17.671,3.106s.875,13.063-2.254,16.6a16.175,16.175,0,0,1-8.733,5.354c-.838.242-8.152.464-9.508-.225-.929-.47-.67-7.684-.96-7.7a1.3,1.3,0,0,1-.98-1.131c.06-.849,1.692-5.829,1.564-6.4S89.784,346.964,94.049,344.037Z",
    transform: "translate(-25.107 -340.384)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M90.105,347.466s5.869-2.291,11.761,4.835c1.271,1.538-2.279,6.792-1.986,7.345.313.6,5.955-3.371,5.67-2.758-2.889,6.257-1.259,10.16-.667,10.286,1.792.379,8.676-8.052,6.969-15.9s-9.593-9.73-11.565-9.6S92.487,341.4,90.105,347.466Z",
    transform: "translate(-23.588 -340.927)",
    fill: "#8d3b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M95.047,348.748c-.932,1.994-1.624,4.755-.547,5.248s2.71-.718,3.641-2.709.812-4-.265-4.5S95.979,346.76,95.047,348.748Z",
    transform: "translate(-16.472 -331.786)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(45.564 209.623)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 8.468,
    height: 1.58,
    transform: "translate(30.448 12.812) rotate(180)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M112.867,415.079a14.7,14.7,0,0,1,1.969,5.946c.134,1.664-.863,5.185-1.96,5.185a81.554,81.554,0,0,0-10.331.576c-3.3.442-4.539,2.342-12.981,2.325-2.467-.008-6.812-.154-6.812-1.165,0-4.374,8.1-2.821,10.673-5.188,6.5-6,10.835-7.445,10.835-7.445S112.639,414.757,112.867,415.079Z",
    transform: "translate(-82.751 -414.979)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(56.975 211.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M94.52,421.9l8.452-.528-.1-1.628-8.452.529Z",
    transform: "translate(-72.592 -408.234)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M115.96,415.76a15.627,15.627,0,0,1,2.359,6c.242,1.712-.516,5.4-1.613,5.468a78.452,78.452,0,0,0-10.271,1.239c-3.265.664-4.374,2.7-12.8,3.208-2.462.145-6.878.268-6.878-.775,0-5.242,7.9-3.41,10.308-6.015,6.092-6.585,10.32-8.348,10.32-8.348S115.709,415.444,115.96,415.76Z",
    transform: "translate(-86.756 -415.703)",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M102.2,374.828s11.135,10.391,11.65,15.306-4.234,20.648-5.915,33.022-2.718,14.876-2.3,17.8,4.089,14.762,3.621,22.634-2.049,28.472-2.049,28.472a21.908,21.908,0,0,1-6.385,1.442c-4.057.393-6.872-3.1-6.872-3.1s-3.265-46.011-3.778-50.864c-.333-3.143-2.9-24.819-3.69-42.49-.254-5.684.393-18.827.39-21.181Z",
    transform: "translate(-30.394 -279.602)",
    fill: "#00233f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M115.6,374.458s2.8,7.348,2.721,13.448c-.068,4.94-1.487,14.012-3.168,26.386s-1.843,23.873-1.425,26.8,3.906,15.294,3.858,23.181c-.054,9.268.738,30.606.738,30.606a40.5,40.5,0,0,1-7.73,1.6,37.279,37.279,0,0,1-9.468-.8s-3.849-48.969-5.678-53.5c-2.92-7.24-3.362-30.039-5.382-45.584-.815-6.274-2.328-20.269-2.328-20.269Z",
    transform: "translate(-27.963 -280.286)",
    fill: "#002d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M95.761,387.038l5.733-20.1s1.977,17.893-.487,19.742A5.141,5.141,0,0,1,95.761,387.038Z",
    transform: "translate(-13.129 -294.183)",
    fill: "#002d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M91.7,355.83l-.581,3.1,6.9-4.073Z",
    transform: "translate(-21.713 -316.533)",
    fill: "#a39d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M105.636,355.956l-2.455-3.28-11.857,7.187,1.875,4.227Z",
    transform: "translate(-21.336 -320.565)",
    fill: "#d7d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M92.9,358.784l-1.084-3.848-1.661,1.291Z",
    transform: "translate(-23.494 -316.387)",
    fill: "#a39d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M92.851,356.546l-2.823,3.219-.431-3.445,2.358-2.256Z",
    transform: "translate(-24.528 -317.997)",
    fill: "#cfcccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M88.047,399.98c-4.208-4.348-1.12-39.324-1.12-39.324l18.052,1.385,3.824,36.868S92.3,404.38,88.047,399.98Z",
    transform: "translate(-31.485 -305.809)",
    fill: "#002d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M86.377,374.47l.553,4.727a172.262,172.262,0,0,0,21.634,0c10.508-.781,10.283-1.507,10.283-1.507l-.487-3.818s-3.205.308-10.559.6C100.654,374.752,86.377,374.47,86.377,374.47Z",
    transform: "translate(-30.482 -281.37)",
    fill: "#004877"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M93.9,374.241l2.523,15.615L99.21,374Z",
    transform: "translate(-16.578 -281.14)",
    fill: "#00233f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M95.133,374.012c.439-3.419,5.752-17.91,15.622-17.685a22.28,22.28,0,0,1,3.277.587l-5.667-2.624s-2.234-.88-6.687,2.408-9.787,10.981-10.445,17.015S94.6,378.106,95.133,374.012Z",
    transform: "translate(-21.638 -317.779)",
    fill: "#002d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M86.231,370.854s.863-12.451,5.168-14.377a24.669,24.669,0,0,0,2.664-1.336s-3.2,5.992-3.915,10.975-.937,8.53-2.573,8.485S86.231,370.854,86.231,370.854Z",
    transform: "translate(-30.789 -316.007)",
    fill: "#002d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M101.466,356.5c4.809-1.9,7.8,1.385,9.348,6.08s5.168,34.316,4.262,35.663-8.134,3.188-9.647,1.442-8.146-27.113-8.727-31.2S95.831,358.729,101.466,356.5Z",
    transform: "translate(-11.934 -314.509)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M99.217,356.784c-1.3,1.484-3.544,8.006-2.792,11.685,1.063,5.208,2.861,19.064,2.861,19.064a18.211,18.211,0,0,0,8.419.453,16.709,16.709,0,0,0,8.129-3.678s-2.824-21.03-5.4-24.506C109.656,358.758,102.818,352.67,99.217,356.784Z",
    transform: "translate(-12.18 -315.578)",
    fill: "#cfcccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M112.387,369.243c5.47,1.333,1.744,12.388-.348,17.693s-9.747,20.149-9.747,20.149l-5.875-1.915a154.17,154.17,0,0,1,6.445-30.107C103.375,373.531,106.825,367.887,112.387,369.243Z",
    transform: "translate(-11.916 -290.315)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(81.133 110.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M98.293,390.576h-.006a1.1,1.1,0,0,1-.932-1.228l.627-4.63a1.1,1.1,0,0,1,1.234-.935h.006a1.1,1.1,0,0,1,.932,1.231l-.63,4.627A1.092,1.092,0,0,1,98.293,390.576Z",
    transform: "translate(-91.332 -373.783)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M97.573,390.547h-.006a1.1,1.1,0,0,1-.932-1.231l.63-4.627a1.092,1.092,0,0,1,1.231-.935H98.5a1.1,1.1,0,0,1,.932,1.231l-.627,4.627A1.1,1.1,0,0,1,97.573,390.547Z",
    transform: "translate(-92.664 -373.837)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M96.874,390.474h-.006a1.1,1.1,0,0,1-.932-1.228l.627-4.627a1.094,1.094,0,0,1,1.234-.935H97.8a1.1,1.1,0,0,1,.932,1.228l-.63,4.627A1.09,1.09,0,0,1,96.874,390.474Z",
    transform: "translate(-93.956 -373.969)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M96.206,390.346l-.006,0a1.1,1.1,0,0,1-.932-1.228l.63-4.63a1.1,1.1,0,0,1,1.234-.935l0,0a1.1,1.1,0,0,1,.935,1.228l-.63,4.63A1.1,1.1,0,0,1,96.206,390.346Z",
    transform: "translate(-95.191 -374.214)",
    fill: "#ffbd95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M99.868,380.267s-4.06,6.579-4.445,8.038-.06,7.345-.06,7.345,2.191-1.5,3.49-1.137,4.573,1.621,4.573,1.621,1.974-4.727,2.151-7.106a23.9,23.9,0,0,0-.2-4.758Z",
    transform: "translate(-95.235 -380.267)",
    fill: "#ffbd95"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M107.211,367.189c2.889,4.829-7.6,9.938-12.844,12.172s-21.192,7.2-21.192,7.2l-2.761-5.527A154.1,154.1,0,0,1,96.379,364.49C97.829,363.781,104.271,362.274,107.211,367.189Z",
    transform: "translate(-60 -300.169)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(0 78.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M68.277,376.76l-.006-.006a1.1,1.1,0,0,1,.222-1.524l3.738-2.8a1.092,1.092,0,0,1,1.53.222l0,0a1.1,1.1,0,0,1-.219,1.527l-3.738,2.8A1.092,1.092,0,0,1,68.277,376.76Z",
    transform: "translate(-64.357 -363.312)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M67.791,376.224l0,0a1.1,1.1,0,0,1,.222-1.527l3.735-2.8a1.1,1.1,0,0,1,1.533.222l0,0a1.1,1.1,0,0,1-.222,1.524l-3.735,2.8A1.1,1.1,0,0,1,67.791,376.224Z",
    transform: "translate(-65.253 -364.297)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M67.351,375.679l0-.006a1.094,1.094,0,0,1,.222-1.524l3.735-2.8a1.1,1.1,0,0,1,1.533.222l0,0a1.1,1.1,0,0,1-.222,1.527l-3.735,2.8A1.1,1.1,0,0,1,67.351,375.679Z",
    transform: "translate(-66.066 -365.311)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M66.975,375.108l0-.006a1.1,1.1,0,0,1,.222-1.524l3.738-2.8a1.092,1.092,0,0,1,1.53.222l.006,0a1.1,1.1,0,0,1-.222,1.524l-3.738,2.8A1.1,1.1,0,0,1,66.975,375.108Z",
    transform: "translate(-66.759 -366.361)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M80.922,369.086s-7.536,1.727-8.844,2.476-5.274,5.117-5.274,5.117,2.61.5,3.262,1.687,2.054,4.394,2.054,4.394,4.752-1.912,6.57-3.456a23.9,23.9,0,0,0,3.251-3.485Z",
    transform: "translate(-66.676 -369.086)",
    fill: "#ffa47c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M112.905,354.439s1.225-10.234-9.166-12.665-14.049,7.941-14.049,7.941a74.237,74.237,0,0,0,13.018,4.262C110.424,355.783,112.905,354.439,112.905,354.439Z",
    transform: "translate(-24.356 -341.406)",
    fill: "#002d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M111.469,349.806s-21.1-1.732-21.338-1.98a23.1,23.1,0,0,0-1.724-1.983c-.513-.413-1.519-.02-1.6-.439s8.587-1.385,8.587-1.385,3.975,1.972,5.961,2.886S111.6,349.113,111.469,349.806Z",
    transform: "translate(-29.689 -336.573)",
    fill: "#004877"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(44.175 342.48)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M59.91,388.463c-4.24-3.328,3.316-11.542,7.211-15.366s16.349-13.8,16.349-13.8l4.368,4a147.862,147.862,0,0,1-17.363,23.833C69.432,388.263,64.223,391.851,59.91,388.463Z",
    transform: "translate(-17.396 -309.403)",
    fill: "#b8d1ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M75.462,364.845l-3.726,3.767-5.9-5.373,3.482-4.174Z",
    transform: "translate(-4.113 -309.822)",
    fill: "#e0f2ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M59.579,355.937c-4.949.715-5.829,5.023-4.809,9.838s11.337,28.358,12.753,29.076,8.357-1.231,8.761-3.482-5.308-23.6-6.835-27.412S65.377,355.1,59.579,355.937Z",
    transform: "translate(-25.279 -315.78)",
    fill: "#b8d1ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M60.607,348.184s-.735,14.819-1.6,15.531c-2.7,2.22-12.442,4.046-14.289,7.924-2.239,4.7,9.739,25.948,11.277,32.954s-1.806,17.825-2.909,24.685,20.434,15.294,21.226,15.3,7.778-6.448,9.115-8.681.14-19.836.168-24.326,1.168-20.209,1.379-21.235a31.194,31.194,0,0,0-.6-13.747c-.256-1.45-.162-3.881-.886-4.812-1.439-1.861-9.5-4.348-9.622-5.274s-1.143-13.8-1.143-13.8Z",
    transform: "translate(-43.685 -329.946)",
    fill: "#ffbd95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M59.5,353.635l12.964,7.847,1.9-5.06s8.528,3.422,9.622,5.274,1.6,5.864,1.955,7.357.527,8.36-.091,14.311c-.365,3.485-.3,8.089-.872,14.021-.484,5.077-.006,17.728-.006,17.728s-4.852.171-12.368-.242c-8.7-.476-18.437-.53-18.827-.852-1.667-1.382,1.7-16.192,1.4-17.685s-10.833-27.384-10.984-30.771A6.894,6.894,0,0,1,48.35,358.7C50.92,357.442,59.5,353.635,59.5,353.635Z",
    transform: "translate(-44.175 -319.866)",
    fill: "#cee0ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M48.661,356.1a9.524,9.524,0,0,1,10.023,2.012c11.736,10.63,19.295,17.836,23.962,20.363,6.228,3.379-5.134,18.625-16.351,18.887-10.838.254-2.5,13.764-2.5,13.764l-10.143-.111c-3.493.667.638-18.169-.67-21.791s-8.3-22.275-8.362-25S48.661,356.1,48.661,356.1Z",
    transform: "translate(-43.346 -316.494)",
    fill: "#b8d1ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M63.283,354.849l-13.131-4.808-.366,7.783,4.044,2.487Z",
    transform: "translate(-33.799 -326.512)",
    fill: "#ffa47c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M67.192,344.249c-3.664-2.587-13.682-4.114-17.605,2.846s-1.051,12.972,2.009,16.531a16.145,16.145,0,0,0,8.607,5.439c.829.251,8.095.57,9.454-.094.932-.456.775-7.63,1.06-7.639a1.3,1.3,0,0,0,.992-1.111c-.048-.843-1.6-5.818-1.464-6.379S71.391,347.218,67.192,344.249Z",
    transform: "translate(-37.693 -341.243)",
    fill: "#ffbd95"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M69.623,347.693s-5.8-2.359-11.761,4.644c-1.282,1.51,2.177,6.781,1.875,7.328-.322.587-5.872-3.433-5.6-2.821,2.787,6.262,1.111,10.117.521,10.234-1.786.353-8.511-8.123-6.707-15.9s9.67-9.539,11.625-9.385S67.338,341.632,69.623,347.693Z",
    transform: "translate(-37.752 -341.783)",
    fill: "#8d3b26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M53.5,348.835c.9,1.994,1.553,4.75.473,5.225s-2.684-.752-3.581-2.744-.752-3.992.328-4.467S52.606,346.844,53.5,348.835Z",
    transform: "translate(-33.763 -332.731)",
    fill: "#ffbd95"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(19.221 208.658)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 8.418,
    height: 1.569,
    transform: "translate(1.639 11.164)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M52.89,415.116a14.661,14.661,0,0,0-1.957,5.909c-.131,1.658.858,5.154,1.949,5.154a80.541,80.541,0,0,1,10.268.573c3.285.442,4.51,2.331,12.907,2.311,2.45-.009,6.9-.16,6.772-1.157s-8.055-2.8-10.61-5.16c-6.465-5.958-10.77-7.4-10.77-7.4S53.118,414.8,52.89,415.116Z",
    transform: "translate(-50.921 -415.017)",
    fill: "#0f0d0d"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M49.987,381.5s-.55,3.408-1.063,8.294,4.211,20.525,5.881,32.828,2.7,14.784,2.288,17.69-4.069,14.671-3.6,22.5,2.037,28.3,2.037,28.3a21.732,21.732,0,0,0,6.345,1.439c4.032.39,6.832-3.083,6.832-3.083s3.242-45.738,3.755-50.562c.333-3.123,2.886-24.671,3.667-42.239.254-5.65-.39-18.716-.387-21.052C75.74,373.99,49.987,381.5,49.987,381.5Z",
    transform: "translate(-35.463 -279.644)",
    fill: "#00233f"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(8.364 210.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M55.94,421.9l-8.4-.526.1-1.619,8.4.528Z",
    transform: "translate(-46.318 -408.315)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M49.5,415.794a15.449,15.449,0,0,0-2.345,5.966c-.239,1.7.513,5.365,1.6,5.436a78.528,78.528,0,0,1,10.211,1.228c3.245.664,4.345,2.687,12.724,3.191,2.445.145,6.9.265,6.835-.769s-7.852-3.391-10.246-5.98c-6.057-6.542-10.26-8.3-10.26-8.3S49.748,415.48,49.5,415.794Z",
    transform: "translate(-47.11 -415.737)",
    fill: "#191919"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M49.2,374.736s-2.786,7.308-2.7,13.371c.066,4.909,1.479,13.927,3.148,26.227s1.832,23.734,1.416,26.637-4.3,15.217-3.835,23.047,2.584,27.144,2.584,27.144a12.321,12.321,0,0,0,6.488,2.536,9.936,9.936,0,0,0,6.416-1.331s4.7-45.815,6.519-50.322c2.9-7.194,3.342-29.859,5.351-45.313.812-6.231,4.613-19.913,4.613-19.913Z",
    transform: "translate(-39.893 -280.846)",
    fill: "#002d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M57.978,355.96l.559,3.083-6.832-4.09Z",
    transform: "translate(-30.251 -317.429)",
    fill: "#b8d1ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M54.1,358.867l1.1-3.818,1.641,1.3Z",
    transform: "translate(-25.816 -317.252)",
    fill: "#b8d1ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M48.922,356.017l2.461-3.244,11.741,7.22-1.891,4.19Z",
    transform: "translate(-35.396 -321.461)",
    fill: "#e0f2ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M54.489,356.645l2.785,3.222.451-3.422-2.33-2.259Z",
    transform: "translate(-25.101 -318.848)",
    fill: "#e0f2ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M46.634,357.3c-4.043,3.18-2.613,7.473.772,11.243s24.68,19.446,26.309,19.357,6.815-5.394,6.017-7.607S62.874,362,59.552,359.381,51.372,353.577,46.634,357.3Z",
    transform: "translate(-44.174 -316.224)",
    fill: "#cee0ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M47.953,374.675s8.7.584,17.312.917,13.816.564,13.816.564l.046,3.419s-8.841.2-17.938-.35c-8.981-.544-14.1-1.339-14.1-1.339Z",
    transform: "translate(-38.784 -280.959)",
    fill: "#3b1b1d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    d: "M.371,0H3.629A.372.372,0,0,1,4,.372V3.587a.372.372,0,0,1-.372.372H.372A.372.372,0,0,1,0,3.587V.371A.371.371,0,0,1,.371,0Z",
    transform: "translate(36.244 95.12)",
    fill: "#722c1d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M54.02,367.256c-2.69,4.906,7.918,9.585,13.215,11.61s21.323,6.357,21.323,6.357l2.533-5.593a153.2,153.2,0,0,0-26.412-15.46C63.211,363.518,56.755,362.264,54.02,367.256Z",
    transform: "translate(-26.764 -301.556)",
    fill: "#cee0ff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(59.686 76.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M72.929,375.911l0-.006a1.083,1.083,0,0,0-.276-1.5l-3.818-2.644a1.088,1.088,0,0,0-1.513.276l0,0a1.1,1.1,0,0,0,.276,1.51l3.821,2.644A1.083,1.083,0,0,0,72.929,375.911Z",
    transform: "translate(-61.407 -362.939)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M73.392,375.363l0-.006a1.092,1.092,0,0,0-.276-1.507L69.3,371.209a1.086,1.086,0,0,0-1.513.279l0,0A1.087,1.087,0,0,0,68.061,373l3.818,2.644A1.091,1.091,0,0,0,73.392,375.363Z",
    transform: "translate(-60.554 -363.952)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M73.807,374.8l0-.006a1.083,1.083,0,0,0-.276-1.5l-3.818-2.644a1.086,1.086,0,0,0-1.513.279l0,0a1.092,1.092,0,0,0,.276,1.507l3.818,2.644A1.091,1.091,0,0,0,73.807,374.8Z",
    transform: "translate(-59.783 -364.99)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M74.158,374.223l0-.006a1.088,1.088,0,0,0-.276-1.5l-3.818-2.644a1.086,1.086,0,0,0-1.513.279l0,.006a1.088,1.088,0,0,0,.276,1.5l3.818,2.644A1.086,1.086,0,0,0,74.158,374.223Z",
    transform: "translate(-59.134 -366.06)",
    fill: "#ffa47c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M65.884,368.537s7.55,1.436,8.878,2.131,5.431,4.883,5.431,4.883-2.573.6-3.177,1.8-1.875,4.442-1.875,4.442-4.792-1.724-6.656-3.188a23.59,23.59,0,0,1-3.362-3.339Z",
    transform: "translate(-65.123 -368.537)",
    fill: "#ffa47c"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 5.644,
    height: 8.558,
    transform: "translate(59.451 74.528) rotate(25.3)",
    fill: "#e0f2ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M67.365,363.824l4.787-5.181,2.956-1.8,5.27,4.7-6.322,4.243L71.731,368.1Z",
    transform: "translate(-1.291 -313.934)",
    fill: "#ffa47c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(69.652 40.866)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M73.672,356.223a2.2,2.2,0,1,0,1.453,2.755A2.208,2.208,0,0,0,73.672,356.223Zm-1.148,3.715a1.683,1.683,0,1,1,2.108-1.114A1.686,1.686,0,0,1,72.524,359.938Z",
    transform: "translate(-64.558 -356.126)",
    fill: "#70655e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(7.883 1.062)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M74.113,356.52a1.8,1.8,0,0,0-.387-.017,2.2,2.2,0,0,0-.65,4.336v0l4.026,1.157a1.053,1.053,0,0,0,1.322-.772l.65-2.69a1.031,1.031,0,0,0-.829-1.271Zm1.342,2.627a1.867,1.867,0,1,1-1.376-2.254A1.87,1.87,0,0,1,75.455,359.147Z",
    transform: "translate(-71.388 -356.499)",
    fill: "#524843"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M71.542,358.091a1.971,1.971,0,1,0,2.376-1.453A1.973,1.973,0,0,0,71.542,358.091Zm3.73.9a1.867,1.867,0,1,1-1.376-2.254A1.87,1.87,0,0,1,75.271,358.992Z",
    transform: "translate(-71.204 -356.343)",
    fill: "#b4aba6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M73.2,359.433a1.87,1.87,0,0,1-1.376-2.254l-.376-.091a2.208,2.208,0,0,0,1.627,2.661v0L77.1,360.9a1.053,1.053,0,0,0,1.322-.772l.313-1.285-3.282-.789A1.87,1.87,0,0,1,73.2,359.433Z",
    transform: "translate(-71.388 -355.408)",
    fill: "#dad3cf",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(0 1.184)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(0 4.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M68.621,363.371a2.3,2.3,0,0,0,.316.5,2.19,2.19,0,0,0,.573.16l4.017-5.374-.889-.664Z",
    transform: "translate(-68.621 -357.99)",
    fill: "#b4aba6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 1.944,
    height: 1.342,
    transform: "translate(2.692 1.559) rotate(-53.308)",
    fill: "#b4aba6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(0.4 0.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M72.493,358.157a.1.1,0,0,0-.134.02l-3.579,4.787a.1.1,0,0,0,.017.134.092.092,0,0,0,.134-.017l3.581-4.792A.093.093,0,0,0,72.493,358.157Z",
    transform: "translate(-68.761 -358.138)",
    fill: "#dad3cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M72.593,358.232a.093.093,0,0,0-.134.02l-3.581,4.787a.1.1,0,0,0,.02.134.1.1,0,0,0,.134-.02l3.581-4.787A.1.1,0,0,0,72.593,358.232Z",
    transform: "translate(-68.579 -358.002)",
    fill: "#dad3cf"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M74.339,357.637l-1.123-.841a1.282,1.282,0,0,0-1.795.259l-1.376,2.071a1.281,1.281,0,0,0,.259,1.792l.88.661a1.287,1.287,0,0,0,1.795-.259L74.6,359.43A1.284,1.284,0,0,0,74.339,357.637Zm-1.593.957c-.479-.356-.735-.823-.573-1.04s.681-.105,1.16.254.735.823.573,1.043S73.225,358.954,72.746,358.595Z",
    transform: "translate(-66.458 -356.541)",
    fill: "#524843"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M76.3,357.205l-.573-.43-.444.593.011.008c.479.356.735.823.573,1.043s-.681.1-1.16-.256l-.009-.009-5.963,7.975a2.191,2.191,0,0,0,.573.16l2.8-3.744.08.06,1.057-1.413a1.274,1.274,0,0,0,1.7-.3L76.556,359A1.284,1.284,0,0,0,76.3,357.205Z",
    transform: "translate(-68.416 -356.109)",
    fill: "#dad3cf",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M70.253,367.089a17.932,17.932,0,0,0,3.507-1.758c.2-.125.573-.211.769-.336.16-.1.39-.4.547-.5s.328-.1.467-.188c.188-.122.316-.453.49-.57.151-.1.49-.225.638-.3.584-.322.339-.71.51-.826a4.018,4.018,0,0,0,.749-.57,9.176,9.176,0,0,0,.493-3.459c-.094-.413-.077-2.852-.322-2.906s-1.088.393-1.262,1.712A10.422,10.422,0,0,1,76.327,360a11.3,11.3,0,0,0-1.1-2.382c-.254-.359-.69-.171-.943.094a4.886,4.886,0,0,0-.134,1.39s-.823-.339-.966-.214c-.49.433-.191,1.342-.188,1.664,0,.271-.752-.433-.943-.219-.718.786.67,2.983-.319,3.393C71.233,363.932,69.7,365.647,70.253,367.089Z",
    transform: "translate(3.827 -316.105)",
    fill: "#ffbd95"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M74.286,357.418c.234.675-.484.561-1.254.764s-2.641.764-2.815.88-1.4.863-1.4.863a7.425,7.425,0,0,1,1.994-2.752C72,356.335,74,356.595,74.286,357.418Z",
    transform: "translate(1.386 -314.275)",
    fill: "#ffa47c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutive);
export default __webpack_public_path__ + "static/media/executive.de75cf2c05384327fccca9cf3522d2a1.svg";
export { ForwardRef as ReactComponent };